var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 900,
    viewBox: "0 0 900 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 242,
    y: 33,
    width: 416,
    height: 860
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450 878.112L246.447 36.5H653.553L450 878.112Z",
    fill: "#FBFAF8",
    stroke: "#04345C",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -4,
    width: 900,
    height: 900
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 446,
    r: 450,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 445,
    fill: "#F59E25",
    stroke: "#FBFAF8",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: -156.981,
    y: 622.428,
    width: 1279.08,
    height: 359.565,
    fill: "#FBFAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 103H625L450 827L275 103Z",
    fill: "#FBFAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5 432C439 432 427.417 429.25 417.75 423.75C408.25 418.083 401.083 410.833 396.25 402C391.417 393.167 389 383.917 389 374.25V373H412.75V374.25C412.75 380.083 414.083 385.917 416.75 391.75C419.583 397.583 424 402.5 430 406.5C436 410.333 443.667 412.25 453 412.25C464 412.25 473.083 409.417 480.25 403.75C487.417 398.083 491 390.417 491 380.75C491 372.75 488.333 366.417 483 361.75C477.833 356.917 471.167 353.667 463 352L437.5 347.25C408.167 340.75 393.5 325.333 393.5 301C393.5 291 395.917 282.25 400.75 274.75C405.583 267.25 412.25 261.5 420.75 257.5C429.417 253.333 439.417 251.25 450.75 251.25C463.583 251.25 474.583 253.833 483.75 259C492.917 264.167 499.833 270.917 504.5 279.25C509.167 287.417 511.5 295.917 511.5 304.75V305.75H487.75V305C487.75 300 486.5 294.917 484 289.75C481.667 284.417 477.667 279.833 472 276C466.5 272.167 459.167 270.25 450 270.25C439.5 270.25 431.083 273.167 424.75 279C418.583 284.833 415.5 292.083 415.5 300.75C415.5 308.083 417.917 314.083 422.75 318.75C427.583 323.417 434.167 326.583 442.5 328.25L465.5 332.75C497.667 339.25 513.75 355 513.75 380C513.75 390.167 511.167 399.167 506 407C501 414.833 493.833 421 484.5 425.5C475.167 429.833 464.5 432 452.5 432Z",
    fill: "#04345C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.652 622.428L450.13 826.92L400.608 622.428H499.652Z",
    fill: "#04345C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/LogoIcon.2e79e0483b2a4fa18a2ad9bf10691fd2.svg";
export { ForwardRef as ReactComponent };